import React, {useEffect, useState} from "react";
import apiService from "../services/apiServices";
import {cacheService} from "../services/cacheService";
import {authStore} from "../store/authStore";
import {observer} from "mobx-react-lite";
import useWebSocket from "react-use-websocket";
import {errorStore} from "../store/errorStore";
import {dashboardStore} from "../store/dashboardStore";
import { participantsStore } from "../store/participantsStore";
import { useNavigate } from 'react-router-dom'

export const Hoc = (Component) => {
    return observer((props) => {
        const Init = () => {
            const token = cacheService.getAuthToken() || " ";
            const [checkToken, setCheckToken] = useState(false);

            const navigate = useNavigate()

            const options = {
                reconnectAttempts: 10,
                reconnectInterval: 1000,
                retryOnError: true,
                onError: (e) => console.log("WebSocket ERROR: ", e)
            };

            const webSocketUrl = process.env.REACT_APP_WEBSOCKET_URL + token.trim();

            const {lastMessage} = useWebSocket(webSocketUrl, options) ?? false;
            const {setDoubleLogin, setInviteMessage} = authStore;
            const {setError, reconnect_internet} = errorStore;
            const {setLikedRoom, setOnlineUsersCount, setInviteData, endCountDown} = dashboardStore;
            const {setAdminUsers} = participantsStore;
            const setUserGuest = () => apiService.setUserGuest()

            useEffect(async () => {
                if (!checkToken) {
                    try {
                        await apiService.getCheckToken();
                        setCheckToken(true);
                    } catch (e) {
                        // setCheckToken(false);
                        const { data: { data: { token, guest_id, username } } } = await setUserGuest()
                        const lang = cacheService.get('Language')
                        cacheService.clear()
                        cacheService.set('Authorization', `Token ${token}`)
                        cacheService.set('UserType', 'guest')
                        cacheService.set('UserName', username)
                        cacheService.set('Id', guest_id)
                        cacheService.set('Language', lang)
                        navigate(0)
                        // console.warn("ERROR: ", e.message);
                    }
                }

                if (lastMessage && checkToken) {
                    const {data: {command, response}} = JSON.parse(lastMessage.data);
                    switch (command) {
                        case "double_login":
                            setDoubleLogin(true);
                            break;
                        case "update_online_users_count":
                            setOnlineUsersCount(response.data);
                            break;
                        case "add_or_remove_admin_role":
                            if(Number(response.data.room_public_id) === Number(cacheService.get("RoomId"))){
                                setAdminUsers(response.data.admins)
                            }
                            break;
                        case "user_room_invite":
                            setInviteMessage(response.message);
                            break;
                        case "likes_total_count":
                            setLikedRoom(response);
                            break;
                        case "invite_home_space":
                            setInviteData(response);
                            break;
                        case "change_room_event_state":
                            const {live_event_start, room_original_name, room, live_event_state} = response
                            endCountDown({room_name: room_original_name, public_id: room, is_live_event: live_event_state, live_event_data: {start:live_event_start}});
                            break;
                    }
                }

            }, [lastMessage]);

            useEffect(() => {
                window.addEventListener("online", reconnect_internet);
                

                window.addEventListener("offline", () => setError({key: "connection_lost"}));
                return () => {
                    window.removeEventListener("online", reconnect_internet);
                    window.removeEventListener("offline", setError);
                };
            }, []);
        };

        Init();

        return <Component {...props}/>;
    });
};

